import { useContext, useEffect } from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  BrowserRouter as Router,
  HashRouter,
  Route,
  Routes,
} from "react-router-dom";

import { userInputs } from "./formSource";
import { DarkModeContext } from "./context/darkModeContext";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import List from "./pages/list/List";

// campaign related route — unified components
import CampaignListIndex from "./pages/Campaign/CampaignListIndex";
import CampaignViewPage from "./pages/Campaign/CampaignViewPage";
import ReviewHubIndex from "./pages/Campaign/ReviewHub/index";
import Inventmelist from "./pages/InventMe/index";
import InventmeView from "./pages/InventMe/View/ArticleView";
// user related route
import RegisterUsersList from "./pages/Roles-permission/Roles/index";
import New from "./pages/new/New";
import UserEdit from "./pages/Roles-permission/Roles/Edit/Rolesedit";
import UserDetailsView from "./pages/Roles-permission/Roles/View/UsersDetails";
import Permission from "./components/notfound/Permssion";
import PermissionRoute from "./auth/PermissionRoute";
import { ADMIN, SUPERADMIN } from "./components/constant/constant";
import UserList from "./pages/users/index";
import UserPermission from "./pages/users/edit/ManagePermission";
//accredited-investers-components
import AccreditedList from "./pages/accreditedInvestors/index";
import UserView from "./pages/users/view/Viewuser";
import ViewAccreditedInvestors from "./pages/accreditedInvestors/viewAccreditedInvestors/viewAccreditedInvestors";




// investment & transaction route
import InvestmentList from "./pages/Investment/index";
import AchFiles from "./pages/Payments/AchFiles/AchFiles";
import WireReconciliation from "./pages/Payments/WireReconciliation/WireReconciliation";
import Closings from "./pages/Payments/Closings/Closings";
import InvestmentView from "./pages/Investment/view/InvestmentView";
import InvestmentEdit from "./pages/Investment/edit/InvestmentEdit";
import TransactionList from "./pages/Transaction/index";
import TransactionView from "./pages/Transaction/view/TransactionView";
import SuitabilityList from "./pages/suitability test/index";
import SuitabilityView from "./pages/suitability test/view/SuitabilityView";




// other route
import SocialList from "./pages/Others/Social Links/index";
import SocialView from "./pages/Others/Social Links/View/Socialview";
import SocialEdit from "./pages/Others/Social Links/Edit/Socialedit";
import LangaugeList from "./pages/Others/Language/index";
import Addlanguage from "./pages/Others/Language/Add/Addlanguage";
import LanguageView from "./pages/Others/Language/View/Viewlanguage";
import LanguageEdit from "./pages/Others/Language/Edit/LanguageEdit";


import Forgot from "./pages/Forgot/Forgot";
import Reset from "./pages/ResetPassword/Reset";


import ManageRole from "./pages/users/ManageRole";
import ManagePermissions from "./pages/users/edit/ManagePermission";
import ManageDesignation from "./pages/users/ManageDesignation";
import ManageDesignationReport from "./pages/users/ManageDesignationReport";
import DesignationReportDetails from "./pages/users/DesignationReportDetails";
import Commission from "./pages/users/Commission";
import JwtAuth from "./components/JwtAuth/JwtAuth";
import ProtectedRoutes from "./auth/ProtectedRoutes";
import PublicRoutes from "./auth/PublicRoutes";
import PrivateRoutes from "./auth/PrivateRoutes";
import NotFound from "./components/notfound/NotFound";
import NewsView from "./pages/News/View/NewsView";
import News from "./pages/News";
import NewsAddEdit from "./pages/News/AddEdit/NewsAddEdit";
import CareersView from "./pages/Careers/View/CareersView";
import Careers from "./pages/Careers";
import CareersAddEdit from "./pages/Careers/AddEdit/CareersAddEdit";
import CareersApplicants from "./pages/Careers/Applicants/CareersApplicants";
// Secondary Market
import SecondaryListingList from "./pages/SecondaryMarket/Listings/SecondaryListingList";
import SecondaryListingView from "./pages/SecondaryMarket/Listings/SecondaryListingView";
import SecondaryTransactionList from "./pages/SecondaryMarket/Transactions/SecondaryTransactionList";
import SecondaryMarketConfigPage from "./pages/SecondaryMarket/Config/SecondaryMarketConfig";

// DR (Dealing Representative) — Phase 1
import DROverview from "./pages/DR/Overview/DROverview";
import DRCredentials from "./pages/DR/Credentials/DRCredentials";
import DRApprovalQueue from "./pages/DR/Approvals/DRApprovalQueue";
import DRApprovalDetail from "./pages/DR/Approvals/DRApprovalDetail";
import ComplianceDecisionList from "./pages/Compliance/Decisions/ComplianceDecisionList";
import ComplianceDecisionDetail from "./pages/Compliance/Decisions/ComplianceDecisionDetail";
import DRSuitabilityFailure from "./pages/DR/Suitability/DRSuitabilityFailure";
import DRDeals from "./pages/DR/Deals/DRDeals";
import DRAudit from "./pages/DR/Audit/DRAudit";

// BDC (Business Development Contractor) — Phase 2, 3-cluster layout per flow image
import BDCOverview from "./pages/BDC/Overview/BDCOverview";
import BDCNetworkDashboard from "./pages/BDC/Network/BDCNetworkDashboard";
import BDCReferrals from "./pages/BDC/Referrals/BDCReferrals";
import BDCPayouts from "./pages/BDC/Payouts/BDCPayouts";
import BDCEntityDetail from "./pages/BDC/Network/BDCEntityDetail";

// AD (Administrator) — Phase D minimum oversight surface
import ADClaimQueue from "./pages/AD/BDCOversight/ClaimQueue";
import ADAttributionEditor from "./pages/AD/BDCOversight/AttributionEditor";
import ADCredentialApprovals from "./pages/AD/DROversight/CredentialApprovals";
import ADManualPaymentConfirm from "./pages/AD/Payments/ManualPaymentConfirm";
import ADComplianceReports from "./pages/AD/ComplianceReports/ComplianceReports";
// AD (Administrator) — Phase E full oversight surface
import ADPayoutAdmin from "./pages/AD/PayoutAdmin/PayoutAdmin";
import ADSLABreachMonitor from "./pages/AD/SLABreachMonitor/SLABreachMonitor";
import ADAuditLogViewer from "./pages/AD/AuditLogViewer/AuditLogViewer";
import ADEmailLogViewer from "./pages/AD/EmailLog/EmailLogViewer";
import ADCampaignComposer from "./pages/AD/Marketing/CampaignComposer";
// AD (Platform Manager) — Phase 5 canonical role model surfaces
import ADConsultantRequestQueue from "./pages/AD/ConsultantRequests/ConsultantRequestQueue";
import ADCommissionRates from "./pages/AD/CommissionRates/CommissionRates";
// DR — Phase E suitability queue
import DRSuitabilityList from "./pages/DR/Suitability/DRSuitabilityList";
import RoleGuard from "./auth/RoleGuard";

import AppLayout from "./components/layout/AppLayout";
import AuthLayout from "./components/layout/AuthLayout";
import { PermissionsProvider } from "./context/permissionContext";
import "./style/utilities.scss";

function App() {
  const { darkMode } = useContext(DarkModeContext);

  useEffect(() => {
    document.documentElement.dataset.theme = darkMode ? "dark" : "light";
  }, [darkMode]);

  return (
    <div className="app">
      <HashRouter>
        <PermissionsProvider>
          <JwtAuth />

          <Routes>
            <Route element={<PublicRoutes />}>
              <Route element={<AuthLayout />}>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<Forgot />} />
                <Route path="/reset-password" element={<Reset />} />
              </Route>
            </Route>

            {/* All private/protected routes */}
            <Route element={<PrivateRoutes />}>
              <Route element={<AppLayout />}>
              <Route path="/" element={<Home />} />

              {/* Review Hub — merges Initial Approval + For Review */}
              <Route
                path="review-hub"
                element={
                  <ProtectedRoutes requiredPath={["Campaign - Initial Approval:View", "Campaign - For Review:View"]}>
                    <ReviewHubIndex />
                  </ProtectedRoutes>
                }
              />

              {/* Campaign routes — unified CampaignListIndex for lists, CampaignViewPage for views */}
              <Route path="initial-approve">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Initial Approval:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Initial Approval:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="active-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Active:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Active:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="rejected-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Rejected:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Rejected:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route path="completed-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Completed:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Completed:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="draft-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Draft:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Draft:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="paused-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Paused campaigns:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Paused campaigns:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="closed-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Closed Campaigns:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Closed Campaigns:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="cancelled-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Cancelled:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Cancelled:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route path="coming-soon-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Upcoming Campaigns:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Upcoming Campaigns:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route path="deleted-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Deleted:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - Deleted:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route path="for-review-campaign">
                <Route
                  path=":campaignId"
                  element={
                    <ProtectedRoutes requiredPath="Campaign - For Review:View">
                      <CampaignViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Campaign - For Review:View">
                      <CampaignListIndex />
                    </ProtectedRoutes>
                  }
                />
              </Route>



              <Route exact path="social-media-links">
                {/* <Route path="add-links" element={<Addadvisory />} /> */}
                <Route path=":socialId" element={<SocialView />} />
                <Route path="edit/:socialId" element={<SocialEdit />} />
                <Route index element={<SocialList />} />
              </Route>
              <Route exact path="language">
                <Route path="add-language" element={<Addlanguage />} />
                <Route path=":langId" element={<LanguageView />} />
                <Route path="edit/:langId" element={<LanguageEdit />} />
                <Route index element={<LangaugeList />} />
              </Route>


              <Route exact path="users">
                <Route
                  path=":userId"
                  element={
                    <ProtectedRoutes requiredPath="Users Management - Users:View">
                      <UserView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Users Management - Users:View">
                      <UserList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="inventme">
                <Route
                  path=":articleId"
                  element={
                    <ProtectedRoutes requiredPath="InventMe Management:View">
                      <InventmeView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="InventMe Management:View">
                      <Inventmelist />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="news">
                <Route
                  path="add-news"
                  element={
                    <ProtectedRoutes requiredPath="News:Edit">
                      <NewsAddEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit-news/:newsId"
                  element={
                    <ProtectedRoutes requiredPath="News:Edit">
                      <NewsAddEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":newsId"
                  element={
                    <ProtectedRoutes requiredPath="News:View">
                      <NewsView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="News:View">
                      <News />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route path="careers">
                <Route
                  path="add-career"
                  element={
                    <ProtectedRoutes requiredPath="News:Edit">
                      <CareersAddEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="edit-career/:id"
                  element={
                    <ProtectedRoutes requiredPath="News:Edit">
                      <CareersAddEdit />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="applicants"
                  element={
                    <ProtectedRoutes requiredPath="News:View">
                      <CareersApplicants />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path=":id"
                  element={
                    <ProtectedRoutes requiredPath="News:View">
                      <CareersView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="News:View">
                      <Careers />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route exact path="accredited-investors">
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Accredited Investors:View">
                      <AccreditedList />
                    </ProtectedRoutes>
                  }
                />
                {/* <Route path=":userId" element={<ViewAccreditedInvestors />} /> */}
              </Route>


              <Route exact path="investment">
                <Route
                  path=":investmentId"
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Investment:View">
                      <InvestmentView />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  path="edit/:investmentId/:campaignId"
                  element={<InvestmentEdit />}
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Investment:View">
                      <InvestmentList />
                    </ProtectedRoutes>
                  }
                />
              </Route>
              <Route
                exact
                path="ach-files"
                element={
                  <ProtectedRoutes requiredPath="Funds Management - Investment:View">
                    <AchFiles />
                  </ProtectedRoutes>
                }
              />
              <Route
                exact
                path="wire-reconciliation"
                element={
                  <ProtectedRoutes requiredPath="Funds Management - Investment:View">
                    <WireReconciliation />
                  </ProtectedRoutes>
                }
              />
              <Route
                exact
                path="campaign-closings"
                element={
                  <ProtectedRoutes requiredPath="Funds Management - Investment:View">
                    <Closings />
                  </ProtectedRoutes>
                }
              />
              <Route exact path="suitability-overview">
                <Route
                  path=":suitabilityId"
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Suitability Overview:View">
                      <SuitabilityView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Suitability Overview:View">
                      <SuitabilityList />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route exact path="transaction">
                <Route
                  path=":transactionId"
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Transaction:View">
                      <TransactionView />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Funds Management - Transaction:View">
                      <TransactionList />
                    </ProtectedRoutes>
                  }
                />
              </Route>


              <Route path="/permission" element={<Permission />} />
              <Route path="/profile" element={<New inputs={userInputs} />} />




              <Route
                path="/manage-role"
                element={
                  <ProtectedRoutes requiredPath="Users Management - Manage System Role:View">
                    <ManageRole />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/manage-designation"
                element={
                  <ProtectedRoutes requiredPath="Users Management - Manage Designations:View">
                    <ManageDesignation />
                  </ProtectedRoutes>
                }
              />
              <Route exact path="designation-report">
                <Route
                  index
                  element={
                    <ProtectedRoutes requiredPath="Users Management - Designation Report:View">
                      <ManageDesignationReport />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  path=":managerId"
                  element={
                    <ProtectedRoutes requiredPath="Users Management - Designation Report:View">
                      <DesignationReportDetails />
                    </ProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/manage-permissions"
                element={
                  <ProtectedRoutes requiredPath="Users Management - Manage Permissions:View">
                    <ManagePermissions />
                  </ProtectedRoutes>
                }
              />

              <Route
                path="/commission"
                element={
                  <ProtectedRoutes requiredPath="Users Management - Manage Commissions:View">
                    <Commission />
                  </ProtectedRoutes>
                }
              />
              {/* Secondary Market — gated for v1 by REACT_APP_SECONDARY_MARKET_ENABLED.
                  When false the four routes do not register at all. Defense-in-depth
                  layer: even with this flag accidentally on, the API kill-switch
                  migration revokes 'Secondary Market:View|Edit' from the AD role,
                  so ProtectedRoutes will still 403. Re-enable in v1.x: flip
                  .env.production + rebuild + re-grant the AD perms. */}
              {process.env.REACT_APP_SECONDARY_MARKET_ENABLED === 'true' && (
                <>
                  <Route exact path="secondary-listings">
                    <Route
                      path=":listingId"
                      element={
                        <ProtectedRoutes requiredPath="Secondary Market:View">
                          <SecondaryListingView />
                        </ProtectedRoutes>
                      }
                    />
                    <Route
                      index
                      element={
                        <ProtectedRoutes requiredPath="Secondary Market:View">
                          <SecondaryListingList />
                        </ProtectedRoutes>
                      }
                    />
                  </Route>
                  <Route
                    path="secondary-transactions"
                    element={
                      <ProtectedRoutes requiredPath="Secondary Market:View">
                        <SecondaryTransactionList />
                      </ProtectedRoutes>
                    }
                  />
                  <Route
                    path="secondary-config"
                    element={
                      <ProtectedRoutes requiredPath="Secondary Market:Edit">
                        <SecondaryMarketConfigPage />
                      </ProtectedRoutes>
                    }
                  />
                </>
              )}

              {/* Compliance queues. DR is a live role again and the
                  hierarchy above it (UDP > CCO > DR) inherits its screens, so
                  every one is gated allow={['AD','DR','CCO','UDP']}: a DR
                  works its own queue, a CCO or UDP works and reviews it, and
                  an AD reaches it for oversight. Paths stay /dr/* — the API
                  legacy mount (/admin/dr/*) keeps serving them, and the
                  Compliance sidebar group links here. RoleGuard is
                  identity-based (hasRole), so these need no DR-* permission
                  seeds. */}
              <Route
                path="dr"
                element={
                  <RoleGuard allow={["AD", "DR", "CCO", "UDP"]}>
                    <DROverview />
                  </RoleGuard>
                }
              />
              <Route
                path="dr/credentials"
                element={
                  <RoleGuard allow={["AD", "DR", "CCO", "UDP"]}>
                    <DRCredentials />
                  </RoleGuard>
                }
              />
              <Route
                path="dr/approvals"
                element={
                  <RoleGuard allow={["AD", "DR", "CCO", "UDP"]}>
                    <DRApprovalQueue />
                  </RoleGuard>
                }
              />
              {/* AD may also land here via the SLA Breach Monitor click-through
                  (Phase F — SLA monitor comment states "AD can make the
                  decision themselves if they need to step in"). The component
                  branches on hasRole('AD') to swap the back-link target and
                  suppress the DR-only CredentialExpiryAlert. AD override
                  semantics + audit capture are enforced server-side. */}
              <Route
                path="dr/approvals/:slaId"
                element={
                  <RoleGuard allow={["AD", "DR", "CCO", "UDP"]}>
                    <DRApprovalDetail />
                  </RoleGuard>
                }
              />
              <Route
                path="dr/suitability"
                element={
                  <RoleGuard allow={["AD", "DR", "CCO", "UDP"]}>
                    <DRSuitabilityList />
                  </RoleGuard>
                }
              />
              <Route
                path="dr/suitability/failed/:id"
                element={
                  <RoleGuard allow={["AD", "DR", "CCO", "UDP"]}>
                    <DRSuitabilityFailure />
                  </RoleGuard>
                }
              />
              <Route
                path="dr/deals"
                element={
                  <RoleGuard allow={["AD", "DR", "CCO", "UDP"]}>
                    <DRDeals />
                  </RoleGuard>
                }
              />
              <Route
                path="dr/audit"
                element={
                  <RoleGuard allow={["AD", "DR", "CCO", "UDP"]}>
                    <DRAudit />
                  </RoleGuard>
                }
              />

              {/* Decision review. A CCO or UDP reviews and reverses what a
                  reviewer decided; an AD reads the same records but decides
                  nothing on them, which the pages enforce with canReview. DR is
                  deliberately NOT admitted: reviewing your own peer group's
                  decisions is the authority that separates CCO from DR. */}
              <Route
                path="compliance/decisions"
                element={
                  <RoleGuard allow={["AD", "CCO", "UDP"]}>
                    <ComplianceDecisionList />
                  </RoleGuard>
                }
              />
              <Route
                path="compliance/decisions/:slaId"
                element={
                  <RoleGuard allow={["AD", "CCO", "UDP"]}>
                    <ComplianceDecisionDetail />
                  </RoleGuard>
                }
              />

              {/* BDC — Phase 2. 3-cluster layout per plan §4.7 +
                  stakeholder flow image. Gated by `BDC - *:View|Edit`
                  permissions seeded in API migration 20260505000009. */}
              <Route
                path="bdc"
                element={
                  <ProtectedRoutes requiredPath="BDC - Overview:View">
                    <BDCOverview />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="bdc/network"
                element={
                  <ProtectedRoutes requiredPath="BDC - Network:View">
                    <BDCNetworkDashboard />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="bdc/referrals"
                element={
                  <ProtectedRoutes requiredPath="BDC - Referrals:View">
                    <BDCReferrals />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="bdc/network/:type/:id"
                element={
                  <ProtectedRoutes requiredPath="BDC - Network:View">
                    <BDCEntityDetail />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="bdc/payouts"
                element={
                  <ProtectedRoutes requiredPath="BDC - Payouts:View">
                    <BDCPayouts />
                  </ProtectedRoutes>
                }
              />

              {/* AD Phase D minimum surface — role-gated (hasRole('AD')). */}
              <Route
                path="ad/bdc-oversight/claims"
                element={
                  <RoleGuard allow="AD">
                    <ADClaimQueue />
                  </RoleGuard>
                }
              />
              <Route
                path="ad/bdc-oversight/attribution"
                element={
                  <RoleGuard allow="AD">
                    <ADAttributionEditor />
                  </RoleGuard>
                }
              />
              <Route
                path="ad/dr-oversight/credentials"
                element={
                  <RoleGuard allow={["AD", "CCO", "UDP"]}>
                    <ADCredentialApprovals />
                  </RoleGuard>
                }
              />
              <Route
                path="ad/payments/pending"
                element={
                  <RoleGuard allow="AD">
                    <ADManualPaymentConfirm />
                  </RoleGuard>
                }
              />
              <Route
                path="ad/reports/compliance"
                element={
                  <RoleGuard allow={["AD", "CCO", "UDP"]}>
                    <ADComplianceReports />
                  </RoleGuard>
                }
              />
              <Route
                path="ad/reports/audit"
                element={
                  <RoleGuard allow={["AD", "CCO", "UDP"]}>
                    <ADAuditLogViewer />
                  </RoleGuard>
                }
              />
              <Route
                path="ad/reports/email-log"
                element={
                  <RoleGuard allow="AD">
                    <ADEmailLogViewer />
                  </RoleGuard>
                }
              />
              <Route
                path="ad/marketing/campaigns"
                element={
                  <RoleGuard allow="AD">
                    <ADCampaignComposer />
                  </RoleGuard>
                }
              />
              <Route
                path="ad/payouts"
                element={
                  <RoleGuard allow="AD">
                    <ADPayoutAdmin />
                  </RoleGuard>
                }
              />
              <Route
                path="ad/dr-oversight/sla-breaches"
                element={
                  <RoleGuard allow={["AD", "CCO", "UDP"]}>
                    <ADSLABreachMonitor />
                  </RoleGuard>
                }
              />

              {/* AD Phase 5 — canonical role model. Consultant invitation
                  approval queue + commission-rate management, both AD-only. */}
              <Route
                path="ad/consultant-requests"
                element={
                  <RoleGuard allow="AD">
                    <ADConsultantRequestQueue />
                  </RoleGuard>
                }
              />
              <Route
                path="ad/commission-rates"
                element={
                  <RoleGuard allow="AD">
                    <ADCommissionRates />
                  </RoleGuard>
                }
              />

              <Route path="*" element={<NotFound />} />
              </Route>
            </Route>
            {/* </Route> */}
          </Routes>
        </PermissionsProvider>
      </HashRouter>
    </div>
  );
}

export default App;
